import React from 'react';

import {FbtBundleConfigContext} from '@udemy/react-discovery-units';

/**
 * Feeds the redesigned "Frequently Bought Together" bundle config into the shared cart success modal
 * (built internally by `@udemy/react-discovery-units` / `ShoppingClient`, so config flows through
 * context rather than props).
 *
 * Must be an ancestor of wherever the add-to-cart success modal mounts.
 */
export const FbtBundleConfigProvider = ({children}: {children: React.ReactNode}) => {
    return (
        <FbtBundleConfigContext.Provider
            value={{
                excludeAddedCourseFromBundle: true, // drop the just-added course (2 courses, not 3)
                showPerCardAddToCart: true, // per-card ATC button + horizontal product-card layout
                hideRelatedLabelsList: true, // remove the related-topics pills
                wideSuccessModal: true, // wider modal (maps to CartSuccessModal size='wide')
            }}
        >
            {children}
        </FbtBundleConfigContext.Provider>
    );
};
